import React from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import '../styles/GoogleMaps.css';

// Opciones del mapa
const containerStyle = {
  width: '100%',
  height: '600px',
};

const MapaGoogle = ({ center, marcador }) => {
  return (

    
  <div className="col-sm-6 hide-576 pads0 map-store-selector-container">
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={14}>
        {marcador && <Marker position={marcador} />}
      </GoogleMap>
  </div>
      
  );
};

export default MapaGoogle;
